module.exports = __webpack_public_path__ + "static/media/loading.c5590569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.svg
// module id = 2186
// module chunks = 0